import { render, staticRenderFns } from "./ArenaSettingsList.vue?vue&type=template&id=0813ae66"
import script from "./ArenaSettingsList.vue?vue&type=script&lang=js"
export * from "./ArenaSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports